import { useContext, useEffect } from 'react';
import LogMessage from '../../../components/misc/LogMessage';
import MyNavigator from '../../../components/misc/MyNavigator';
import NavBar from '../../../components/misc/NavBar';
import SideBar from '../../../components/misc/SideBar';
import SettingsEditProfileModal from '../../../components/settings/SettingsEditProfileModal';
import { toIcons } from '../../../consts/Paths';
import { possible_statuses } from '../../../consts/possible_statuses';
import MainContext from '../../../context/MainContext';
import useIsMobile from '../../../hooks/useIsMobile';
import useLogMessage from '../../../hooks/useLogMessage';
import useToggle from '../../../hooks/useToggle';

const UserDetailsPage = (props: any) => {
    const { isMobile } = useIsMobile();
    const menuToggler = useToggle(false);
    const navigateNow = useToggle(false);
    const logMessage = useLogMessage();

    /* modals */
    const editProfileModalToggler = useToggle(false);
    const createUserModalToggler = useToggle(false);
    /*  */

    const anyModalOpen = editProfileModalToggler.isToggled || createUserModalToggler.isToggled;

    const { userTreated, setClient } = useContext(MainContext);

    const tempLoading = useToggle(false);

    useEffect(() => {
        if (editProfileModalToggler.isToggled) {
            createUserModalToggler.toggle();
        } else if (createUserModalToggler.isToggled) {
            editProfileModalToggler.toggle();
        }
    }, []);

    useEffect(() => {
        if (userTreated === null && window.location.pathname.includes('/user/')) {
            navigateNow.setIsToggled(true);
        }
    }, []);

    const handleGoBack = () => {
        setClient(null);
        navigateNow.setIsToggled(true);
    };

    return (
        <div className='page-wrapper'>
            <MyNavigator path={`/settings`} trigger={navigateNow} />
            {(!isMobile || menuToggler.isToggled) && <SideBar toggler={menuToggler} />}
            {editProfileModalToggler.isToggled && <SettingsEditProfileModal toggler={editProfileModalToggler} user={userTreated} isMainUser={false} logMessage={logMessage} />}
            <div>
                {isMobile && <NavBar toggler={menuToggler} />}
                <div
                    className={`page-content ${isMobile && menuToggler.isToggled ? (menuToggler.isToggledSecondary ? 'slide-right' : 'slide-left') : ''}`}
                    style={{
                        maxWidth: isMobile ? '' : 'calc(100vw - 256px)',
                        minWidth: isMobile ? '' : '1105px',
                        marginLeft: isMobile ? (menuToggler.isToggled ? '256px' : '') : '256px',
                        display: anyModalOpen && isMobile ? 'none' : '',
                    }}
                >
                    {logMessage.isToggled && (
                        <LogMessage
                            text={{
                                subject: logMessage.message.subject,
                                other_text: logMessage.message.other_text,
                                complement: logMessage.message.complement,
                            }}
                            bgColor={logMessage.message.bgColor}
                        />
                    )}
                    <div
                        className='header-box'
                        style={{
                            width: isMobile ? '345px' : '',
                            margin: isMobile ? '' : ' 56px 64px 0',
                        }}
                    >
                        <div
                            className='general-header'
                            style={{
                                margin: isMobile ? '30px 15px' : '0',
                                width: '90%',
                            }}
                        >
                            <div
                                className='Oval'
                                onClick={handleGoBack}
                                style={{
                                    marginRight: isMobile ? 'auto' : '',
                                }}
                            >
                                <img src={`${toIcons}/small-left.svg`} />
                            </div>
                        </div>
                        <button
                            className='button1'
                            type='submit'
                            onClick={editProfileModalToggler.toggle}
                            style={{
                                width: isMobile ? '56px' : '122px',
                            }}
                        >
                            <img className='white' src={`${toIcons}/edit.svg`} />
                            {!isMobile && <p className='button1-text'>Edit</p>}
                        </button>
                    </div>
                    <div
                        className='settings-card shadow'
                        style={{
                            width: isMobile ? '345px' : '',
                            margin: isMobile ? '28px 15px' : '',
                            height: isMobile ? '345px' : '',
                        }}
                    >
                        <div
                            className='settings-card-content-wrapper'
                            style={{
                                margin: isMobile ? '48px 20px' : '',
                            }}
                        >
                            <div
                                className='settings-card-header'
                                style={{
                                    flexDirection: isMobile ? 'column' : 'row',
                                    alignItems: isMobile ? 'flex-start' : '',
                                }}
                            >
                                <p
                                    className='model-details-card-info-name'
                                    style={{
                                        fontSize: isMobile ? '32px' : '',
                                    }}
                                >{`${userTreated?.name} ${userTreated?.surname}`}</p>
                                {userTreated?.roles && userTreated?.roles[1].role === possible_statuses.userType.admin && (
                                    <div className='settings-card-header-role-box'>
                                        <p className='settings-card-header-role'>{userTreated?.roles[1].role}</p>
                                    </div>
                                )}
                            </div>
                            <div className='settings-card-info-box'>
                                <p className='settings-card-info-description'>Your login data</p>
                                <div
                                    className='client-details-card-row'
                                    style={{
                                        flexDirection: isMobile ? 'column' : 'row',
                                        gap: isMobile ? '25px' : '',
                                    }}
                                >
                                    <div className='client-details-card-info-spec-box'>
                                        <p className='client-details-card-info-spec-field'>E-mail</p>
                                        <p className='client-details-card-info-spec-value'>{userTreated?.email}</p>
                                    </div>
                                    <div className='client-details-card-info-spec-box'>
                                        <p className='client-details-card-info-spec-field'>Password</p>
                                        <input
                                            className='client-details-card-info-spec-value'
                                            type={'password'}
                                            value={userTreated?.password}
                                            disabled={true}
                                            style={{
                                                boxShadow: 'none',
                                                marginTop: '-8px',
                                                backgroundColor: 'transparent',
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default UserDetailsPage;
